import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: {},
  token: null,
  countries: [],
  country: null,
  area: null,
  prevLogin: null,
  loggedIn: false,
  isLoggedIn: false,
  routeParams: null,
};

export const authSlice = createSlice({
  name: 'userAuth',
  initialState,
  reducers: {
    saveUser: (state, { payload }) => {
      state.user = payload;
    },
    saveToken: (state, { payload }) => {
      state.token = payload;
    },
    setCredentials: (state, { payload }) => {
      state.user = payload.user;
      state.token = payload.token;
    },
    saveCountries: (state, { payload }) => {
      state.countries = payload;
    },
    saveArea: (state, { payload }) => {
      state.area = payload;
    },
    saveCountry: (state, { payload }) => {
      state.country = payload;
    },
    clearUser: (state) => {
      state.user = {};
    },
    clearToken: (state) => {
      state.token = null;
    },
    logout: (state) => {
      state.token = null;
      state.user = {};
      state.market = null;
      state.loggedIn = false;
      state.isLoggedIn = false;
    },
    saveToUserAuth: (state, { payload }) => {
      state[payload?.key] = payload.value;
    },
    saveToAuth: (state, { payload }) => {
      state[payload[0]] = payload[1];
    },
  },
});

export const {
  saveUser,
  clearUser,
  saveToken,
  saveCountries,
  saveArea,
  saveCountry,
  clearToken,
  setCredentials,
  logout,
  saveToUserAuth,
  saveToAuth,
} = authSlice.actions;

export default authSlice.reducer;
